export const MAX_SEASONS = 3;